"use client";

import Image from "next/image";
import CustomPagination from "@/components/card-pagination";
import SupplyCard from "@/components/supply-card";
import DemandCard from "@/components/demand-card";
import { usePaginationQuery } from "@/hook/pagination-query";

const AdvertisementsList = ({ data, page, pageSize, searchParams }: any) => {
  const { handlePageChange, handlePageSizeChange } =
    usePaginationQuery(searchParams);

  if (!data?.count) {
    return (
      <div className="flex w-full justify-center items-center flex-col md:flex-row gap-10">
        <div className="pt-12 pl-10 text-center text-gray-500 text-lg font-medium">
          متاسفانه نتیجه‌ای پیدا نشد, پیشنهاد می‌کنیم فیلترهای انتخابی خود را
          بازبینی کنید.
        </div>
        <div className="relative md:w-125 md:h-125 w-75 h-75">
          <Image
            src={"/assets/empty-properties.svg"}
            alt="property ads not found"
            fill
            sizes="256px"
            style={{ objectFit: "contain" }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {data?.results.map((ad: any) => {
          const isSupply = ad.ad_type === "عرضه";
          const key = ad.id || ad.ad_id;

          return isSupply ? (
            <SupplyCard key={key} ad={ad} />
          ) : (
            <DemandCard key={key} ad={ad} />
          );
        })}
      </div>
      
      <CustomPagination
        page={page - 1}
        pageSize={pageSize}
        count={data?.count ?? 0}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        consultantsList={true}
      />
    </div>
  );
};

export default AdvertisementsList;
